import { FC, useEffect, useState } from "react";
import { Release } from "models/release";
import ReactMarkdown from "react-markdown";
import RemarkGfm from "remark-gfm";
import "./ReleaseOverview.css";

export type ReleaseOverviewProps = {
    release: Release;
    onClose: () => void;
}

const LibraryOverview: FC<ReleaseOverviewProps> = ({release, onClose}) => {
    const [readMe, setReadMe] = useState("");

    useEffect(() => {
        if(!release.readme) {
            setReadMe("");
            return;
        }

        const mdDownload = async (url: string) => {
            try 
            {
                const response = await fetch(url);
                const content = await response.text();
                setReadMe(content);
            }
            catch {
                console.warn(`Failed to download or process readme from ${url}`);
                setReadMe("");
            }
        };

        void mdDownload(release.readme);
    }, [release]);

    return (
        <div>
            <section className="container-padding"></section>
            <button onClick={onClose} className="close-button" title="Sluiten">✗</button>
            <h5>{release.extension} ({release.version})</h5>          
            <hr />
            <ReactMarkdown plugins={[RemarkGfm]} >
                { readMe }
            </ReactMarkdown>
        </div>
    )
};

export default LibraryOverview;